import * as ContentServices from '../enums/content-services.js'
import Metrics from '../services/metrics'
import superagent from 'superagent'
import q from 'q'
import * as miscEnum from '../enums/misc'
import Environment from '../plugins/environment/index'

let activeUploadRequest = null
const UPLOAD_TIMEOUT = 1800000

export default class ContentServiceClient {
  constructor(apiClient, sdkClient) {
    this.apiClient = apiClient
    this.resourceApi = new sdkClient.ResourcesApi(apiClient)
    this.transactionsApi = new sdkClient.TransactionsApi(apiClient)
    this.searchCPApi = new sdkClient.VsearchcpApi(apiClient)
    this.cpApi = new sdkClient.VcpApi(apiClient)
  }

  getContentUrl() {
    return this.apiClient.getContentUrl()
  }

  searchForContent(options) {
    return this.defaultRegionSearch(options)
  }
  searchUsingCSSDK(options) {
    return new Promise((resolve, reject) => {
      this.searchCPApi.cpSearch(options, (error, data, response) => {
        if (error) {
          Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.CONTENT_SEARCH_ERROR, 1, Metrics.TYPE.FAILURE_COUNTER, error)
          reject(error)
        } else {
          Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.CONTENT_SEARCH_SUCCESS, 1, Metrics.TYPE.OCCURRENCE_COUNTER)
          resolve(response.body)
        }
      })
    })
  }

  defaultRegionSearch(options) {
    const requestQueryParams = {
      q: options['q'],
      limit: options['limit'],
      nextPageToken: options['nextPageToken'],
      grades: this.apiClient.buildCollectionParam(options['grades'], 'csv'),
      subjects: this.apiClient.buildCollectionParam(options['subjects'], 'csv'),
      componentTypes: this.apiClient.buildCollectionParam(options['componentTypes'], 'csv'),
      labels: this.apiClient.buildCollectionParam(options['labels'], 'csv'),
      tags: this.apiClient.buildCollectionParam(options['tags'], 'csv'),
      author: options['author'],
      languages: this.apiClient.buildCollectionParam(options['languages'], 'csv'),
      countries: this.apiClient.buildCollectionParam(options['countries'], 'csv'),
      standardStrands: this.apiClient.buildCollectionParam(options['standardStrands'], 'csv'),
      standardSets: this.apiClient.buildCollectionParam(options['standardSets'], 'csv'),
      sortBy: options['sortBy'],
      langPrefer: options['langPrefer']
    }
    // remove any properties that don't have a value
    Object.keys(requestQueryParams).forEach(param => {
      if (requestQueryParams[param] === undefined || requestQueryParams[param] === null) {
        delete requestQueryParams[param]
      }
    })
    let deferred = q.defer()
    let request = superagent('GET', Environment.serviceRegionUrl('default', 'cs') + '/v2/search/cp/content')
    request.accept('application/json')
    request.timeout(this.apiClient.getRequestTimeout())
    request.query(requestQueryParams)
    request.end(function (error, response) {
      if (error) {
        Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.CONTENT_SEARCH_ERROR, 1, Metrics.TYPE.FAILURE_COUNTER, error)
        deferred.reject(error)
      } else {
        Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.CONTENT_SEARCH_SUCCESS, 1, Metrics.TYPE.OCCURRENCE_COUNTER)
        deferred.resolve(response.body)
      }
    })
    return deferred.promise
  }

  resourceShareInfo(shareId) {
    let deferred = q.defer()
    let request = superagent('GET', this.apiClient.buildUrl('/v2/share/shareInfo'))
    request.accept('application/json')
    request.timeout(this.apiClient.getRequestTimeout())
    request.query({shareId: shareId})
    request.end(function (error, response) {
      if (error) {
        deferred.reject(error)
      } else {
        deferred.resolve(response.body)
      }
    })
    return deferred.promise
  }

  uploadNewResource(file) {
    let deferred = q.defer()
    let request = superagent('POST', this.apiClient.buildUrl('/v2/cp/upload'))
    this.apiClient.applyAuthToRequest(request, ['oauth2'])
    request.timeout(UPLOAD_TIMEOUT)
    request.attach('fileStream', file)
    request.accept('application/json')
    request.on('progress', deferred.notify)
    request.end(function (error, response) {
      activeUploadRequest = null
      if (error) {
        Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.UPLOAD_RESOURCE_ERROR, 1, Metrics.TYPE.FAILURE_COUNTER, error)
        deferred.reject(error)
      } else {
        deferred.resolve({
          contentId: response.body.contentId,
          transactionId: response.body.transactionId
        })
      }
    })
    activeUploadRequest = request
    return deferred.promise
  }

  updateResource(contentId, file) {
    let deferred = q.defer()
    let request = superagent('PUT', this.apiClient.buildUrl('/v2/resources/' + contentId))
    this.apiClient.applyAuthToRequest(request, ['oauth2'])
    request.timeout(UPLOAD_TIMEOUT)
    request.attach('fileStream', file)
    request.accept('application/json')
    request.on('progress', deferred.notify)
    request.end(function (error, response) {
      activeUploadRequest = null
      if (error) {
        Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.UPDATE_RESOURCE_ERROR, 1, Metrics.TYPE.FAILURE_COUNTER, error)
        deferred.reject(error)
      } else {
        deferred.resolve({transactionId: response.header['x-smarttech-transaction-id']})
      }
    })
    activeUploadRequest = request
    return deferred.promise
  }
  transactionStatus(transactionId) {
    let deferred = q.defer()
    let request = superagent('GET', this.apiClient.buildUrl(`/v2/transactions/${transactionId}/status`))
    this.apiClient.applyAuthToRequest(request, ['oauth2'])
    request.timeout(this.apiClient.getRequestTimeout())
    request.accept('application/json')
    request.on('progress', deferred.notify)
    request.end(function (error, response) {
      if (error) {
        deferred.reject(error)
      } else {
        deferred.resolve(response)
      }
    })
    return deferred.promise
  }

  cancelResourceUpload() {
    if (activeUploadRequest) {
      activeUploadRequest.abort()
    }
    activeUploadRequest = null
  }

  getTransactionStatus(transactionId) {
    return new Promise((resolve, reject) => {
      /* eslint-disable no-unused-vars */
      this.transactionsApi.getTransactionStatus(transactionId, (error, data, response) => {
        if (error) {
          reject(error)
        } else {
          resolve(response)
        }
      })
    })
  }

  getTransactionDetails(transactionId) {
    return new Promise((resolve, reject) => {
      /* eslint-disable no-unused-vars */
      this.transactionsApi.getTransactionDetails(transactionId, (error, data, response) => {
        if (error) {
          reject(error)
        } else {
          resolve(response)
        }
      })
    })
  }

  getContentProfileWithBaseUrl(baseProfileUrl, fields) {
    fields = fields || miscEnum.GETPROFILE_FIELDS
    const requestQueryParams = {
      fields: this.apiClient.buildCollectionParam(fields, 'csv')
    }
    let deferred = q.defer()
    let request = superagent('GET', baseProfileUrl)
    request.query(requestQueryParams)
    request.end(function (error, response) {
      if (error) {
        Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.CONTENT_PROFILE_ERROR, 1, Metrics.TYPE.FAILURE_COUNTER, error)
        deferred.reject(error)
      } else {
        Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.CONTENT_PROFILE_SUCCESS, 1, Metrics.TYPE.OCCURRENCE_COUNTER)
        deferred.resolve(response.body.data)
      }
    })
    return deferred.promise
  }
  getContentProfile(contentIds, fields) {
    fields = fields || miscEnum.GETPROFILE_FIELDS
    let opts = {contentIds, fields}
    return new Promise((resolve, reject) => {
      /* eslint-disable no-unused-vars */
      this.resourceApi.getContentProfiles(opts, (error, data, response) => {
        if (error) {
          Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.CONTENT_PROFILE_ERROR, 1, Metrics.TYPE.FAILURE_COUNTER, error)
          reject(error)
        } else {
          Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.CONTENT_PROFILE_SUCCESS, 1, Metrics.TYPE.OCCURRENCE_COUNTER)
          resolve(response.body.data)
        }
      })
    })
  }

  putContent(id, updates) {
    return new Promise((resolve, reject) => {
      /* eslint-disable no-unused-vars */
      this.resourceApi.putContent(id, updates, (error, data, response) => {
        if (error) {
          Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.PUT_CONTENT_METADATA_ERROR, 1, Metrics.TYPE.FAILURE_COUNTER, error)
          reject(error)
        } else {
          Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.PUT_CONTENT_METADATA_SUCCESS, 1, Metrics.TYPE.OCCURRENCE_COUNTER)
          resolve(response)
        }
      })
    })
  }

  initContent(id, metadata) {
    return new Promise((resolve, reject) => {
      this.cpApi.initCpMetadata(id, metadata, (error, data, response) => {
        if (error) {
          Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.INIT_CP_METADATA_ERROR, 1, Metrics.TYPE.FAILURE_COUNTER, error)
          reject(error)
        } else {
          Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.INIT_CP_METADATA_SUCCESS, 1, Metrics.TYPE.OCCURRENCE_COUNTER)
          resolve(response)
        }
      })
    })
  }

  uploadSharedResource(contentId, file) {
    let jsonShare = {
      'resourceId': contentId,
      'contentType': file.type,
      'grantType': 'LINK',
      'permission': ['READ', 'WRITE', 'DELETE'],
      'memberIds': []
    }
    return new Promise((resolve, reject) => {
      /* eslint-disable no-unused-vars */
      this.shareApi.createShare(jsonShare, (error, data, response) => {
        if (error) {
          reject(error)
        } else {
          resolve(response)
        }
      })
    })
  }

  getSharedResources() {
    return new Promise((resolve, reject) => {
      this.shareApi.getOwnerSharedContent((error, data) => {
        if (error) {
          reject(error)
        } else {
          resolve(data)
        }
      })
    })
  }

  getResourceMetadata(contentId) {
    return new Promise((resolve, reject) => {
      this.getContentProfile([contentId])
        .then((data) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getPreviewUrl(contentId) {
    return new Promise((resolve, reject) => {
      this.getContentProfile([contentId])
        .then((data) => {
          let urls = []
          let imagePreviewList = data['previewList']
          imagePreviewList.forEach((imageInfo) => {
            let cdnUrl = imageInfo.url
            let imageRes = imageInfo.s3Info.resolution
            urls.push({url: cdnUrl, res: imageRes})
          }, this)

          resolve(urls)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  deleteSharedResource(shareId) {
    return new Promise((resolve, reject) => {
      /* eslint-disable no-unused-vars */
      this.shareApi.revokeSharedContent(shareId, (error, data, response) => {
        if (error) {
          reject(error)
        } else {
          resolve(response)
        }
      })
    })
  }

  // TODO update CS sdk once we have the moderation api's released
  // deleteResource(contentId) {
  //   return new Promise((resolve, reject) => {
  //     /* eslint-disable no-unused-vars */
  //     this.resourceApi.deleteResource(contentId, (error, data, response) => {
  //       if (error) {
  //         reject(error)
  //       } else {
  //         resolve(response)
  //       }
  //     })
  //   })
  // }

  getPaginatedSharedResources(options) {
    return new Promise((resolve, reject) => {
      let opts = {}

      // Add pagination options
      if (typeof options.offset !== 'undefined') {
        opts.limit = options.limit
        opts.offset = options.offset
      }

      // Add sorting options
      if (options.sortBy) {
        opts.sortBy = options.sortBy
        if (options.sortOrder && options.sortOrder === ContentServices.DESCENDING) {
          opts.sortBy = '-' + opts.sortBy
        }
      }

      // Set filetype
      if (options.filetype) {
        if (options.filetype === 'application/x-smarttech-notebook') {
          opts.resourceType = ContentServices.NOTEBOOK
        }
      }

      this.recommendationsContentApi.getContent(ContentServices.OWNED_BY_ME, opts, (error, data) => {
        if (error) {
          reject(error)
        } else {
          let ids = []
          data.contents.forEach(item => {
            ids.push(item.contentId)
          })
          resolve(ids)
        }
      })
    })
  }

  uploadSmexSharedResource(id, filename) {
    let opts = {
      filename
    }
    return new Promise((resolve, reject) => {
      this.smexApi.putResource(id, opts, (error, data, response) => {
        if (error) {
          reject(error)
        } else {
          resolve(JSON.parse(response.text))
        }
      })
    })
  }

  downloadSharedResourceUrl(contentId, shareId) {
    let options = {shareId}
    return new Promise((resolve, reject) => {
      this.resourceApi.getResource(contentId, options, (error, data, response) => {
        if (error) {
          Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.FETCH_DOWNLOAD_URL_ERROR, 1, Metrics.TYPE.FAILURE_COUNTER, error)
          reject(error)
        } else {
          Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.FETCH_DOWNLOAD_URL_SUCCESS, 1, Metrics.TYPE.OCCURRENCE_COUNTER)
          let text = JSON.parse(response.text)
          resolve(text.resourceUrl)
        }
      })
    })
  }

  getModerationMetadata() {
    let deferred = q.defer()
    let request = superagent('GET', this.apiClient.buildUrl('/v2/cp/mod/metadata'))
    this.apiClient.applyAuthToRequest(request, ['oauth2'])
    request.timeout(this.apiClient.getRequestTimeout())
    request.accept('application/json')
    request.end(function (error, response) {
      if (error) {
        Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.FETCH_MODERATED_METADATA_ERROR, 1, Metrics.TYPE.FAILURE_COUNTER, error)
        deferred.reject(error)
      } else {
        Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.FETCH_MODERATED_METADATA_SUCCESS, 1, Metrics.TYPE.FAILURE_COUNTER)
        deferred.resolve(response.body.modInfo)
      }
    })
    return deferred.promise
  }

  getModerationResources(status, nextPageToken) {
    let deferred = q.defer()
    let request = superagent('GET', this.apiClient.buildUrl('/v2/cp/mod'))
    this.apiClient.applyAuthToRequest(request, ['oauth2'])
    request.query({'status': status})
    if (nextPageToken) {
      request.query({'nextPage': nextPageToken})
    }
    request.timeout(this.apiClient.getRequestTimeout())
    request.accept('application/json')
    request.end(function (error, response) {
      if (error) {
        Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.FETCH_MODERATED_RESOURCE_ERROR, 1, Metrics.TYPE.FAILURE_COUNTER, error)
        deferred.reject(error)
      } else {
        Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.FETCH_MODERATED_RESOURCE_SUCCESS, 1, Metrics.TYPE.OCCURRENCE_COUNTER)
        deferred.resolve({
          'data': response.body.data,
          'nextPageToken': response.body.nextPageToken
        })
      }
    })
    return deferred.promise
  }

  deleteResource(contentId) {
    let deferred = q.defer()
    let request = superagent('DELETE', this.apiClient.buildUrl('/v2/resources/' + contentId))
    this.apiClient.applyAuthToRequest(request, ['oauth2'])
    request.timeout(this.apiClient.getRequestTimeout())
    request.accept('application/json')
    request.end(function (error, response) {
      if (error) {
        Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.DELETE_RESOURCE_ERROR, 1, Metrics.TYPE.FAILURE_COUNTER, error)
        deferred.reject(error)
      } else {
        deferred.resolve({'data': response.body})
      }
    })
    return deferred.promise
  }

  modResourceStatus(contentId, status, declineInfo, declineReasons) {
    let deferred = q.defer()
    let request = superagent('PUT', this.apiClient.buildUrl('/admin/admin_portal/mod'))
    this.apiClient.applyAuthToRequest(request, ['oauth2'])
    request.timeout(this.apiClient.getRequestTimeout())
    request.accept('application/json')
    request.send({modUpdates: [{
      contentId,
      status,
      declineInfo,
      declineReasons
    }]})
    request.end(function (error, response) {
      if (error) {
        Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.PUT_MODERATION_STATUS_ERROR, 1, Metrics.TYPE.FAILURE_COUNTER, error)
        deferred.reject(error)
      } else {
        Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.PUT_MODERATION_STATUS_SUCCESS, 1, Metrics.TYPE.OCCURRENCE_COUNTER)
        deferred.resolve({'data': response.body})
      }
    })
    return deferred.promise
  }

  getModerationQue(status, nextPageToken, limit, contentIds) {
    let deferred = q.defer()
    let request = superagent('GET', this.apiClient.buildUrl('/admin/admin_portal/mod'))
    this.apiClient.applyAuthToRequest(request, ['oauth2'])
    if (contentIds) {
      request.query({'contentIds': contentIds})
    } else if (status) {
      request.query({'status': status})
    }
    if (nextPageToken) {
      request.query({'nextPageToken': nextPageToken})
    }
    if (limit) {
      request.query({'limit': limit})
    }
    request.query({'sortBy': 'lastModTime'})
    request.timeout(this.apiClient.getRequestTimeout())
    request.accept('application/json')
    request.end(function (error, response) {
      if (error) {
        Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.FETCH_MODERATION_QUEUE_ERROR, 1, Metrics.TYPE.FAILURE_COUNTER, error)
        deferred.reject(error)
      } else {
        Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.FETCH_MODERATION_QUEUE_SUCCESS, 1, Metrics.TYPE.OCCURRENCE_COUNTER)
        deferred.resolve({
          'data': response.body.data,
          'nextPageToken': response.body.nextPageToken
        })
      }
    })
    return deferred.promise
  }
}
